<template>
	<div class="py-2 meta-key-form">
		<v-text-field
			v-model="metaKey.name"
			type="text"
			class="ma-1"
			label="項目名（必須）"
			:rules="[rules.required]"
			outlined
			dense
		/>
		<v-select
			v-model="metaKey.meta_type"
			label="型（必須）"
			:rules="[rules.required]"
			:items="metaTypes"
			class="ma-1"
			item-text="name"
			item-value="id"
			@change="changeMetaType"
			:hint="
				metaKey.daily_report_meta_options_attributes.length
					? '型を変更すると選択肢はリセットされます。'
					: ''
			"
			:persistent-hint="metaKey.daily_report_meta_options_attributes.length != 0"
			outlined
			dense
		/>
		<v-select
			v-if="metaKey.meta_type == 'association'"
			v-model="metaKey.association_name"
			label="関連データを選択（必須）"
			:rules="[rules.required]"
			:items="polymorphicOptions"
			class="ma-1"
			item-text="name"
			item-value="id"
			outlined
			dense
		/>
		<v-row v-else-if="metaKey.meta_type != 'boolean'" no-gutters class="ma-1 flex-nowrap" >
			<v-select
				v-model="metaKey.option_type"
				label="選択肢を設定（必須）"
				class="mr-1"
				:rules="[rules.required]"
				:items="optionTypes"
				item-text="name"
				item-value="id"
				outlined
				dense
				:hint="metaKey.meta_type == null ? '型を先に指定してください。' : ''"
				:persistent-hint="metaKey.meta_type == null"
				:disabled="metaKey.meta_type == null"
				@change="changeOptionType"
			/>
			<v-btn
				class="ml-1"
				@click="addMetaOption"
				color="secondary"
				:disabled="metaKey.option_type == 'not_required' || metaKey.meta_type == null"
			>
				<v-icon small>mdi-plus</v-icon>
				選択肢を追加
			</v-btn>
		</v-row>
		<template v-if="metaKey.option_type != 'not_required' && metaKey.meta_type != null">
			<MetaOptionForm
				v-for="(option, i) in metaKey.daily_report_meta_options_attributes"
				:key="i"
				:metaOption.sync="metaKey.daily_report_meta_options_attributes[i]"
				:index="i"
				:metaType="metaKey.meta_type"
				@remove-meta-option="removeMetaOption($event)"
			/>
		</template>
		<v-row class="ma-1" justify="space-between">
			<v-checkbox
				dense
				v-model="metaKey.required_flag"
				label="必須項目に指定する"
				:value="true"
				class="mr-2"
				hide-details
			/>
			<v-spacer />
			<v-row class="ma-0" justify="end">
				<template v-if="!hideDeleteBtn">
					<v-menu offset-y close-on-click>
						<template v-slot:activator="{ on, attrs }">
							<v-btn text color="red" v-bind="attrs" v-on="on" dense> 項目を削除する </v-btn>
						</template>

						<v-list>
							<v-list-item @click="$emit('remove-meta-key')">
								<v-list-item-title color="red" class="text-body-2"
									>本当に削除する</v-list-item-title
								>
							</v-list-item>
						</v-list>
					</v-menu>
				</template>
				<!-- <template v-else>
					<v-menu offset-y close-on-click>
						<template v-slot:activator="{ on, attrs }">
							<v-btn text color="red" v-bind="attrs" v-on="on" dense> アーカイブする </v-btn>
						</template>

						<v-list>
							<v-list-item @click="archiveMetaKey(metaKey.id)">
								<v-list-item-title color="red" class="text-body-2"
									>アーカイブする</v-list-item-title
								>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-hover v-slot="{ deleteTip }" close-delay="200" open-delay="200">
						<div>
							<v-btn text color="red" @click.stop="deleteMenu = true" dense> 項目を削除する </v-btn>
							<v-tooltip bottom v-show="deleteTip">
								<span>項目は完全削除され、表示されなくなります。</span>
							</v-tooltip>
						</div>
					</v-hover>
					<v-menu v-mode="deleteMenu" offset-y close-on-click>
						<v-list>
							<v-list-item @click="deleteMetaKey(metaKey.id)">
								<v-list-item-title color="red" class="text-body-2"
									>本当に削除する</v-list-item-title
								>
							</v-list-item>
						</v-list>
					</v-menu>
				</template> -->
			</v-row>
		</v-row>
	</div>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"
import MetaOptionForm from "./DailyReportMetaOptionForm.vue"

export default {
	props: {
		metaKeyData: {
			id: {
				type: Number,
				required: false,
				default: null,
			},
			name: {
				type: String,
				required: true,
				default: null,
			},
			meta_type: {
				type: String,
				required: true,
				default: null,
			},
			required_flag: {
				type: Boolean,
				required: true,
				default: false,
			},
			option_type: {
				type: String,
				required: true,
				default: false,
			},
			association_name: {
				type: String,
				required: true,
				default: false,
			},
		},
		metaTypes: {
			type: Array,
			required: true,
		},
		optionTypes: {
			type: Array,
			required: true,
		},
		polymorphicOptions: {
			type: Array,
			required: true,
		},

		hideDeleteBtn: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	components: {
		MetaOptionForm,
	},
	data() {
		return {
			rules: rules,
			deleteMenu: false,
			deleteTip: false,
			archiveMenu: false,
			archiveTip: false,
		}
	},
	methods: {
		changeMetaType() {
			if (this.metaKey.meta_type == "association") {
				this.metaKey.option_type = "not_required"
			} else if (this.metaKey.meta_type == "boolean") {
				this.metaKey.option_type = "not_required"
				this.metaKey.association_name = null
			} else {
				this.metaKey.association_name = null
			}

			this.metaKey.daily_report_meta_options_attributes = []
			if (this.metaKey.option_type != "not_required") {
				this.metaKey.daily_report_meta_options_attributes.push({
					value_text: null,
					value_string: null,
					value_integer: null,
					value_float: null,
					value_date: null,
					value_time: null,
					value_datetime: null,
					value_boolean: null,
				})
			}
		},
		changeOptionType() {
			if (this.metaKey.option_type == "not_required") {
				this.metaKey.daily_report_meta_options_attributes = []
			} else {
				if (!this.metaKey.daily_report_meta_options_attributes.length) {
					this.metaKey.daily_report_meta_options_attributes.push({
						value_text: null,
						value_string: null,
						value_integer: null,
						value_float: null,
						value_date: null,
						value_time: null,
						value_datetime: null,
						value_boolean: null,
					})
				}
			}
		},
		addMetaOption() {
			this.metaKey.daily_report_meta_options_attributes.push({
				value_text: null,
				value_string: null,
				value_integer: null,
				value_float: null,
				value_date: null,
				value_time: null,
				value_datetime: null,
				value_boolean: null,
			})
		},
		removeMetaOption(i) {
			this.metaKey.daily_report_meta_options_attributes.splice(i, 1)
		},
		deleteMetaKey(id) {
			const status = "deleted"
			this.updateStatus(id, status)
		},
		archiveMetaKey(id) {
			const status = "archived"
			this.updateStatus(id, status)
		},
		updateStatus(id, status) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_meta_keys/${id}`
			axios
				.patch(url, { daily_report_meta_key: { status } }, { headers })
				.then((res) => {
					let message = null
					if (res.data == "deleted") {
						message = "追加項目を削除しました。"
					} else if (res.data == "archived") {
						message = "追加項目をアーカイブしました。"
					}
					this.$emit("delete-meta-key", id)
					this.$store.dispatch("setFlash", {
						text: message,
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		metaKey: {
			get() {
				return this.metaKeyData
			},
			set(newValue) {
				return this.$emit("update:metaKey", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>